import { useEffect, useState } from "react";
import axios from "axios";

// Public marketing-copy overrides set by admins in Settings → Site content.
// Shape: { home: {eyebrow, headline, subheadline, bullets[]}, services: {slug: {short, hero, description}} }
export default function useSiteContent() {
  const [content, setContent] = useState({});
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/site-content`)
      .then(({ data }) => setContent(data || {}))
      .catch(() => {});
  }, []);
  return content;
}
